// extracted by mini-css-extract-plugin
export default {"managerLayout":"ManagerLayout_managerLayout__J9yFz","managerMain":"ManagerLayout_managerMain__eyWmG","menuHidden":"ManagerLayout_menuHidden__9Nark"};